import { operations } from './__generated__';
import type { OperationId, OperationSpec } from './types';

/**
 * Return the API operation for an API operation ID.
 */
export function getAPIOperation(operationId: OperationId): OperationSpec<OperationId> {
    return operations[operationId];
}
